module.exports = __webpack_public_path__ + "img/female7.3a83e231.jpeg";